import React from 'react';
import { Formik, FormikProps, Form, Field } from 'formik';
import FormInput from '../../shared/Inputs/FormInput';
import Button from 'shared/Button/Button';
import * as Yup from 'yup';
import FormSelect from 'shared/Inputs/FormSelect';
import { AdminTypeProps, Club } from 'store/admins/types';
import { ReducerItemsState } from 'shared/interface/globalInterface';
import apiClient from 'apiClient';

type Props = {
  error: string;
  onSubmit: (values: AdminTypeProps) => void;
  clubs: ReducerItemsState<Club>;
};

const validationSchema = Yup.object().shape(
  {
    fcaNumber: Yup.string()
      .when('club', {
        is: (club: string) => !!club,
        then: Yup.string().test('val', 'Only FCA Number or Club can be provided.', (fcaNumber: string) => !fcaNumber),
      })
      .when('club', {
        is: (club: string) => !club,
        then: Yup.string()
          .test({
            name: 'fcaExists',
            test: async function(value) {
              try {
                await apiClient.get(`/api/v1/broker-management/company-data/${value}`);
              } catch (e) {
                return this.createError({
                  message: `FCA Number doesn't exist in our database`,
                });
              }

              return true;
            },
          })
          .required('FCA Number or Club is required.'),
      }),
    club: Yup.string()
      .when('fcaNumber', {
        is: (fcaNumber: string) => !!fcaNumber,
        then: Yup.string().test('val', 'Only FCA Number or Club can be provided.', (club: string) => !club),
      })
      .when('fcaNumber', {
        is: (fcaNumber: string) => !fcaNumber,
        then: Yup.string().required('FCA Number or Club is required.'),
      }),
  },
  [['club', 'fcaNumber']],
);

const initialFormData = {
  fcaNumber: '',
  club: '',
};

const CreateAdminForm: React.FC<Props> = ({ error, onSubmit, clubs }: Props) => {
  return (
    <Formik initialValues={initialFormData} onSubmit={onSubmit} validationSchema={validationSchema}>
      {({ values }: FormikProps<any>) => {
        return (
          <Form className="form register-firm">
            <Field
              name="fcaNumber"
              component={FormInput}
              label="FCA Registration Number"
              helperText="Please enter the Firm/Network FCA number."
            />

            {clubs.pending ? (
              'Fetching clubs..'
            ) : (
              <Field
                name="club"
                component={FormSelect}
                label="Club"
                helperText="Please select the Club from the drop-down list below."
                options={clubs.items.map((club) => ({
                  id: `club-${club.id}`,
                  value: club.id,
                  option: club.name,
                }))}
              />
            )}

            <div className="form__navigation">
              <span className="form-failure">{error}</span>
              <Button className="form__submit" type="submit" label="Next" />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default CreateAdminForm;
